<template>
  <div class="introduction-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>介绍说明</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          v-if="category.length"
          @click="
            $router.push({
              name: 'introductionAdd',
              query: {
                ...$route.query,
              },
            })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <div class="introduction-main">
      <el-card class="introduction-main-left" :body-style="{ padding: '0px' }">
        <div slot="header">
          <div class="introduction-header">
            <span>类别</span>
          </div>
        </div>
        <div class="introduction-menu">
          <div style="flex: 1" v-bar>
            <div>
              <Draggable
                v-model="category"
                @change="changeCategory"
                :animation="150"
              >
                <div
                  v-for="item in category"
                  :key="item.value"
                  class="introduction-menu-item"
                  :class="{
                    menuActive: item.value === $route.query.t,
                  }"
                  @click="getCategoryDetails(item)"
                >
                  <p class="omitText">{{ item.name }}</p>
                  <div class="introduction-btn">
                    <i
                      class="el-icon-delete"
                      @click.stop="showDelPopup(item)"
                    ></i>
                    <i
                      class="el-icon-edit"
                      @click.stop="showEditPopup(item)"
                    ></i>
                  </div>
                </div>
              </Draggable>
            </div>
          </div>
          <button
            class="global-button-style"
            style="margin: 0"
            @click="showAddPopup"
          >
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </el-card>
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap" ref="wrap">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :height="tableHeight"
            style="width: 100%; height: 100%; overflow-y: scroll"
          >
            <el-table-column
              type="index"
              align="center"
              fixed="left"
              label="序号"
              :key="Math.random()"
              width="50"
            >
              <template slot-scope="scope">
                <span>{{
                  (params.page - 1) * params.limit + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="title" align="center" label="标题">
            </el-table-column>
            <el-table-column v-if="showLang" align="center" label="语言">
              <template slot-scope="scope">
                <span>{{ fomatLang(scope.row.lang) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updatedAt" align="center" label="日期">
              <template slot-scope="scope">
                <span>{{ scope.row.updatedAt | filterDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updatedAt" align="center" label="发布状态">
              <template slot-scope="scope">
                <span v-if="scope.row.public === 0">未发布</span>
                <span v-if="scope.row.public === 1" class="green">已发布</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="管理" align="center">
              <template slot-scope="scope">
                <!--<span @click="toView(scope.row._id)" class="checkDetailsBtn">查看详情</span>-->
                <span @click="toEdit(scope.row._id)" class="checkDetailsBtn"
                  >编辑</span
                >
                <span @click="toPublic(scope.row)" class="checkDetailsBtn">{{
                  scope.row.public === 0 ? "发布" : "撤回"
                }}</span>
                <span @click="toDel(scope.row._id)" class="delBtn">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="pageNum"
        />
      </el-card>
    </div>
    <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    <AddComponent
      v-if="addPopup"
      :title="title"
      :ruleForm="ruleForm"
      :ruleProps="title === '新建' ? ruleProps : editRuleProps"
      :rules="rules"
      @addEvn="addEvn"
    />
  </div>
</template>

<script>
import AddComponent from "@/components/addPopup";
import DelPopup from "@/components/delPopup";
import Pagination from "@/components/pagination";
import Draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  components: {
    Draggable,
    AddComponent,
    DelPopup,
    Pagination,
  },
  computed: {
    ...mapGetters(["addPopup", "delPopup"]),
    tableHeight() {
      return window.innerHeight - 250;
    },
    rules() {
      let rules = {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        value: [
          {
            required: true,
            message: "请输入key(不可以与其他分类重复)",
            trigger: "blur",
          },
        ],
      };
      return rules;
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: "标题",
          placeholder: "请输入标题",
        },
        {
          prop: "value",
          label: "key",
          placeholder: "请输入key(不可以与其他分类重复)",
        },
      ];
      return ruleProps;
    },
    editRuleProps() {
      let ruleProps = [
        {
          prop: "name",
          label: "标题",
          placeholder: "请输入标题",
        },
      ];
      return ruleProps;
    },
    showLang() {
      return [
        "membership-service",
        "starnote-privacy-policy",
        "starnote-service",
        "galaxy-information-checklist",
        "sign-in-activity", //  签到活动说明
        "payment-policy", //  支付政策
        "booxreader-privacy-policy", //  阅读器隐私政策
        "booxreader-service", //  阅读器用户协议
      ].includes(this.$route.query.t);
    },
  },
  watch: {},
  data() {
    return {
      category: [],
      ruleForm: {
        name: "",
        value: "",
      },
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, sortBy: "updatedAt" },
      updateId: "",
      deleteType: "",
      currentCategory: null,
      title: "",
      keys: [],
    };
  },
  created() {
    this.getLogsCategory();
  },
  methods: {
    async getLogsCategory() {
      let res = await this.$http.getLogsCategory({ limit: 1000 });
      this.category = res.data.results;
      if (!this.category.length) return;
      this.keys = this.category.map((item) => item.value);
      if (!this.$route.query.t) {
        this.getCategoryDetails(this.category[0]);
      } else {
        this.getList();
      }
    },
    async getCategoryDetails(item) {
      this.$router.push({
        name: "introduction",
        query: {
          k: item.name,
          t: item.value,
        },
      });
      this.params.page = 1;
      this.getList();
    },
    // 表格操作按钮
    tableHandle(type) {
      if (type === "del") {
        this.$http.delUpdate(this.updateId).then((res) => {
          this.updateId = "";
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
          this.getList();
        });
      }
    },
    //  确认删除
    deleteHandle() {
      if (this.deleteType === "list") {
        this.tableHandle("del");
      } else {
        this.delCategory();
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },
    getList() {
      this.params.version = this.$route.query.t;
      this.$http.getUpdateList(this.params).then((res) => {
        this.tableData = res.data.results;
        this.total = res.data.count;
      });
    },
    toEdit(id) {
      this.$router.push({
        name: "introductionAdd",
        query: { id, ...this.$route.query },
      });
    },
    toDel(id) {
      this.updateId = id;
      this.deleteType = "list";
      this.$store.commit("windowHandle", "delPopup");
    },
    toPublic(item) {
      let { _id: id } = item;
      let type = item.public === 0 ? 1 : 0;
      this.$http
        .publicUpdate({ id, data: { id, public: type } })
        .then((res) => {
          this.getList();
          this.elMsg(this.$t("alertMsg.editSuccess"), "success");
        });
    },
    toView(id) {
      this.$router.push({ name: "updateView", query: { id } });
    },
    pageNum(page) {
      this.params.page = page;
      this.getList();
    },
    async addEvn(data) {
      if (this.keys.includes(data.value)) {
        this.elMsg(`当前的key已存在,请重新输入`, "error");
        return;
      }
      if (this.title === "新建") {
        this.addLogsCategory(data);
      } else {
        this.updateLogsCategory(data);
      }
    },
    async addLogsCategory(data) {
      await this.$http.addLogsCategory(data);
      this.$store.commit("windowHandle");
      this.getLogsCategory();
    },
    async updateLogsCategory(data) {
      let params = {
        cateId: this.currentCategory._id,
        ...data,
      };
      await this.$http.updateLogsCategory(params);
      this.$store.commit("windowHandle");
      this.getLogsCategory();
    },
    async delCategory() {
      await this.$http.delLogsCategory({ cateId: this.currentCategory._id });
      let idx = this.category.findIndex(
        (item) => item._id === this.currentCategory._id
      );
      this.category.splice(idx, 1);
      this.keys = this.category.map((item) => item.value);
      if (!this.category.length) {
        this.$router.push({
          name: "introduction",
        });
      } else if (this.currentCategory.value === this.$route.query.t) {
        this.getCategoryDetails(this.category[0]);
      }
    },
    showAddPopup() {
      this.title = "新建";
      this.ruleForm = {
        name: "",
        value: "",
      };
      this.$store.commit("windowHandle", "addPopup");
    },
    showEditPopup(item) {
      this.title = "编辑";
      this.currentCategory = item;
      this.ruleForm = {
        name: item.name,
      };
      this.$store.commit("windowHandle", "addPopup");
    },
    showDelPopup(item) {
      this.deleteType = "category";
      this.currentCategory = item;
      this.$store.commit("windowHandle", "delPopup");
    },
    async changeCategory({ moved }) {
      let { newIndex, oldIndex, element } = moved;
      let ordinal;
      if (newIndex === 0) {
        // 拖到第一位置
        let timeStamp = new Date().getTime();
        ordinal = (this.category[newIndex + 1].ordinal + timeStamp) / 2;
      } else if (newIndex === this.category.length - 1) {
        // 拖到最后位置
        let oldLastItem = this.category[newIndex - 1];
        ordinal = oldLastItem.ordinal;
        if (this.category.length === 2) {
          let timeStamp = new Date().getTime();
          oldLastItem.ordinal = timeStamp;
        } else {
          oldLastItem.ordinal =
            (ordinal + this.category[newIndex - 2].ordinal) / 2;
        }
        let params = {
          cateId: oldLastItem._id,
          ordinal: oldLastItem.ordinal,
        };
        await this.$http.updateLogsCategory(params);
      } else {
        ordinal =
          (this.category[newIndex + 1].ordinal +
            this.category[newIndex - 1].ordinal) /
          2;
      }
      let params = {
        cateId: element._id,
        ordinal,
      };
      await this.$http.updateLogsCategory(params);
    },
    fomatLang(lang) {
      switch (lang) {
        case "zh":
          return "中文";
        case "zhTW":
          return "繁体中文";
        case "en":
          return "英文";
      }
      return lang;
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.introduction-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .introduction-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .introduction-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      .introduction-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .introduction-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .introduction-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          > p {
            flex: 1;
          }
          &:hover {
            background: #f3f6f9;
            > .introduction-btn {
              display: block;
            }
          }
          .introduction-btn {
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
}
</style>
